(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-free-shipping-upsell"] && !Shopify.designMode) return;
  try {
    class CartFreeShippingUpsell extends HTMLElement {
    #cartSyncAbortController = null;
    #boundCartUpdate = this.#handleCartUpdate.bind(this);
    #cartUpdateTimeout = null;
    #upsellContainer = null;
    #removedContainerColorClasses = [];

    connectedCallback() {
      this.#upsellContainer = this.closest('.cart-drawer__upsell, .cart-drawer__upsell-top, .cart-page__upsell');

      // Initialize after first paint so dependent cart nodes are available.
      requestAnimationFrame(() => {
        this.updateProgress();
        this.#updateProductsEmptyStateFromDom();
        this.#syncProductsWithCartItems(window.Shopify?.cart?.items);
      });

      // Listen for cart updates
      document.addEventListener('cart:update', this.#boundCartUpdate);
    }

    disconnectedCallback() {
      this.#cartSyncAbortController?.abort();
      if (this.#cartUpdateTimeout) {
        clearTimeout(this.#cartUpdateTimeout);
        this.#cartUpdateTimeout = null;
      }
      this.#setProductsEmptyState(false);
      this.#upsellContainer = null;
      this.#removedContainerColorClasses = [];
      document.removeEventListener('cart:update', this.#boundCartUpdate);
    }

    async #fetchCartItems() {
      const controller = new AbortController();
      this.#cartSyncAbortController?.abort();
      this.#cartSyncAbortController = controller;

      try {
        const response = await fetch('/cart.js', {
          method: 'GET',
          headers: {
            Accept: 'application/json',
          },
          signal: controller.signal,
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch cart: HTTP ${response.status}`);
        }

        const cart = await response.json();
        return Array.isArray(cart?.items) ? cart.items : [];
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.warn('Failed to sync upsell products with cart:', error);
        }
        return null;
      } finally {
        if (this.#cartSyncAbortController === controller) {
          this.#cartSyncAbortController = null;
        }
      }
    }

    #syncProductsWithCartItems(cartItems) {
      if (!Array.isArray(cartItems)) {
        this.#updateProductsEmptyStateFromDom();
        return;
      }

      const productRows = this.querySelectorAll('.cart-free-shipping-upsell__product[data-product-id]');
      if (productRows.length === 0) {
        this.#updateProductsEmptyStateFromDom();
        return;
      }

      const cartProductIds = new Set(
        cartItems
          .map((item) => {
            if (item?.product_id !== undefined && item?.product_id !== null) {
              return String(item.product_id);
            }
            if (item?.product?.id !== undefined && item?.product?.id !== null) {
              return String(item.product.id);
            }
            return '';
          })
          .filter(Boolean)
      );

      let visibleProducts = 0;
      productRows.forEach((row) => {
        const productId = row.getAttribute('data-product-id');
        const shouldHide = !!productId && cartProductIds.has(productId);
        row.toggleAttribute('hidden', shouldHide);
        if (!shouldHide) visibleProducts += 1;
      });

      const productsSection = this.querySelector('.cart-free-shipping-upsell__products');
      if (productsSection) {
        productsSection.toggleAttribute('hidden', visibleProducts === 0);
      }

      this.#setProductsEmptyState(visibleProducts === 0);
    }

    #hasProductRows() {
      return this.querySelector('.cart-free-shipping-upsell__product[data-product-id]') !== null;
    }

    #isProductsEnabled() {
      return this.dataset.showProducts === 'true';
    }

    #countVisibleProductRows() {
      return this.querySelectorAll('.cart-free-shipping-upsell__product[data-product-id]:not([hidden])').length;
    }

    #setProductsEmptyState(isEmpty) {
      const shouldApplyEmptyState = this.#isProductsEnabled() && isEmpty;
      this.classList.toggle('cart-free-shipping-upsell--products-empty', shouldApplyEmptyState);

      const upsellContainer =
        this.#upsellContainer || this.closest('.cart-drawer__upsell, .cart-drawer__upsell-top, .cart-page__upsell');
      if (!this.#upsellContainer && upsellContainer) {
        this.#upsellContainer = upsellContainer;
      }

      if (upsellContainer) {
        upsellContainer.classList.toggle(
          'cart-free-shipping-upsell-container--products-empty',
          shouldApplyEmptyState
        );
      }

      this.#toggleContainerColorSchemeClass(shouldApplyEmptyState);
    }

    #updateProductsEmptyStateFromDom() {
      this.#setProductsEmptyState(this.#countVisibleProductRows() === 0);
    }

    #toggleContainerColorSchemeClass(shouldRemove) {
      const upsellContainer =
        this.#upsellContainer || this.closest('.cart-drawer__upsell, .cart-drawer__upsell-top, .cart-page__upsell');
      if (!upsellContainer) return;

      if (shouldRemove) {
        if (this.#removedContainerColorClasses.length === 0) {
          this.#removedContainerColorClasses = Array.from(upsellContainer.classList).filter(
            (className) => className.startsWith('color-') || className.startsWith('color-scheme-')
          );
        }

        this.#removedContainerColorClasses.forEach((className) => {
          upsellContainer.classList.remove(className);
        });
        return;
      }

      if (this.#removedContainerColorClasses.length > 0) {
        upsellContainer.classList.add(...this.#removedContainerColorClasses);
        this.#removedContainerColorClasses = [];
      }
    }

    async #handleCartUpdate(event) {
      // Try to get cart total from event if available
      if (event?.detail?.resource?.total_price) {
        this.dataset.currentTotal = event.detail.resource.total_price.toString();
      }

      // Wait a bit for DOM to update after cart change, and debounce burst updates.
      if (this.#cartUpdateTimeout) {
        clearTimeout(this.#cartUpdateTimeout);
      }

      this.#cartUpdateTimeout = setTimeout(async () => {
        this.updateProgress();

        const eventItems = event?.detail?.resource?.items;
        if (Array.isArray(eventItems)) {
          this.#syncProductsWithCartItems(eventItems);
          this.#cartUpdateTimeout = null;
          return;
        }

        if (!this.#hasProductRows()) {
          this.#updateProductsEmptyStateFromDom();
          this.#cartUpdateTimeout = null;
          return;
        }

        const latestCartItems = await this.#fetchCartItems();
        this.#syncProductsWithCartItems(latestCartItems);
        this.#cartUpdateTimeout = null;
      }, 100);
    }

    updateProgress() {
      const progressFill = this.querySelector('.cart-free-shipping-upsell__progress-fill');
      const messageContainer = this.querySelector('.cart-free-shipping-upsell__message');
      
      if (!messageContainer) return;
      
      // Read thresholds from data attributes
      // Use getAttribute as primary method since it's more reliable for kebab-case attributes
      const tier1ThresholdAttr = this.getAttribute('data-tier-1-threshold');
      const tier2ThresholdAttr = this.getAttribute('data-tier-2-threshold');
      
      // Parse the threshold values, using defaults only if attributes are missing or invalid
      let tier1Threshold = 30000;
      if (tier1ThresholdAttr !== null && tier1ThresholdAttr !== '') {
        const parsed = parseInt(tier1ThresholdAttr);
        if (!isNaN(parsed) && parsed > 0) {
          tier1Threshold = parsed;
        }
      }
      
      let tier2Threshold = 50000;
      if (tier2ThresholdAttr !== null && tier2ThresholdAttr !== '') {
        const parsed = parseInt(tier2ThresholdAttr);
        if (!isNaN(parsed) && parsed > 0) {
          tier2Threshold = parsed;
        }
      }
      
      // Get text templates from data attributes
      const tier1TextBefore = this.dataset.tier1TextBefore || this.dataset['tier-1-text-before'] || '🎁 Добави продукти за {amount} и получи подаръци - Магнезиев цитрат и Левзея Макс!';
      const tier1TextAchieved = this.dataset.tier1TextAchieved || this.dataset['tier-1-text-achieved'] || '🎉 Честито! Получихте подаръците - Магнезиев цитрат и Левзея Макс!';
      const tier2TextBefore = this.dataset.tier2TextBefore || this.dataset['tier-2-text-before'] || '🎁 Толкова си близо! Добави продукти за {amount} и получи още един подарък - Апетит Стоп!';
      const tier2TextAchieved = this.dataset.tier2TextAchieved || this.dataset['tier-2-text-achieved'] || '🎉 Честито! Получи още един подарък Апетит Стоп!';
      
      // Get current cart total - start with value from Liquid (most reliable, already in cents)
      let currentTotal = parseInt(this.dataset.currentTotal || '0');
      
      // Only try to update if we don't have a valid value from Liquid
      // This prevents parsing errors from overriding the correct value
      if (currentTotal === 0) {
        // Try to get updated value from Shopify cart object (most reliable for updates)
        const cartData = window.Shopify?.cart;
        if (cartData?.total_price) {
          currentTotal = cartData.total_price;
          this.dataset.currentTotal = currentTotal.toString();
        } else {
          // Last resort: try to parse from DOM element
          const cartTotalElement = document.querySelector('[data-cart-subtotal]');
          if (cartTotalElement) {
            // Try to get from value attribute first (more reliable)
            const valueAttr = cartTotalElement.getAttribute('value');
            const textToParse = valueAttr || cartTotalElement.textContent || cartTotalElement.innerText || '';
            
            if (textToParse) {
              // Match price format: "€20,00" or "20,00 €" or "20.00" - match the main price number
              // Look for pattern: optional currency symbol, digits (with optional thousands separators) with comma or dot decimal separator
              // This regex handles: "€20,00", "€350,00", "€1.234,56", "20,00", "350.00", etc.
              const priceMatch = textToParse.match(/(?:€|EUR|EUR\s*)?([\d]{1,3}(?:[.\s][\d]{3})*(?:[.,][\d]{2})?|[\d]+(?:[.,][\d]{2})?)/);
              if (priceMatch) {
                // Handle European format: remove thousands separators, convert comma to dot
                // "20,00" -> "20.00", "350,00" -> "350.00", "1.234,56" -> "1234.56"
                let totalStr = priceMatch[1];
                // Remove thousands separators (dots or spaces)
                totalStr = totalStr.replace(/[.\s]/g, '');
                // Convert comma decimal separator to dot
                totalStr = totalStr.replace(',', '.');
                const totalValue = parseFloat(totalStr);
                if (!isNaN(totalValue) && totalValue > 0) {
                  const parsedTotal = Math.round(totalValue * 100);
                  // Only update if the parsed value seems reasonable
                  if (parsedTotal > 0 && parsedTotal < 10000000) {
                    currentTotal = parsedTotal;
                    this.dataset.currentTotal = currentTotal.toString();
                  }
                }
              }
            }
          }
        }
      }
      
      // Determine tier status
      const tier1Achieved = currentTotal >= tier1Threshold;
      const tier2Achieved = currentTotal >= tier2Threshold;
      
      // Always calculate progress based on final tier (tier 2)
      const finalThreshold = tier2Threshold;
      const progress = Math.min((currentTotal / finalThreshold) * 100, 100);
      
      // Calculate tier marker positions
      const tier1Position = (tier1Threshold / finalThreshold) * 100;
      const tier2Position = 100;
      
      // Determine active threshold and amount needed
      let activeThreshold, amountNeeded, displayText;
      
      if (tier1Achieved && !tier2Achieved) {
        activeThreshold = tier2Threshold;
        amountNeeded = Math.max(0, tier2Threshold - currentTotal);
        
        // Format amount and replace placeholder
        const formattedAmount = new Intl.NumberFormat('bg-BG', {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 2
        }).format(amountNeeded / 100);
        
        displayText = tier2TextBefore.replace(/{amount}/g, formattedAmount);
        
        messageContainer.innerHTML = `
          <div class="cart-free-shipping-upsell__text cart-free-shipping-upsell__text--tier-achieved">
            ${tier1TextAchieved}
          </div>
          <div class="cart-free-shipping-upsell__text">
            ${displayText}
          </div>
        `;
      } else if (!tier1Achieved) {
        activeThreshold = tier1Threshold;
        amountNeeded = Math.max(0, tier1Threshold - currentTotal);
        
        // Format amount and replace placeholder
        const formattedAmount = new Intl.NumberFormat('bg-BG', {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 2
        }).format(amountNeeded / 100);
        
        displayText = tier1TextBefore.replace(/{amount}/g, formattedAmount);
        
        messageContainer.innerHTML = `
          <div class="cart-free-shipping-upsell__text">
            ${displayText}
          </div>
        `;
      } else {
        // Both tiers achieved
        activeThreshold = tier2Threshold;
        amountNeeded = 0;
        
        messageContainer.innerHTML = `
          <div class="cart-free-shipping-upsell__text cart-free-shipping-upsell__text--success">
            ${tier2TextAchieved}
          </div>
        `;
      }
      
      if (progressFill) {
        progressFill.style.width = `${progress}%`;
        progressFill.dataset.progress = progress.toFixed(1);
      }
      
      // Update tier markers
      const markers = this.querySelectorAll('.cart-free-shipping-upsell__progress-marker');
      markers.forEach(marker => {
        const tier = parseInt(marker.dataset.tier);
        const isAchieved = tier === 1 ? tier1Achieved : tier2Achieved;
        
        if (isAchieved) {
          marker.classList.add('cart-free-shipping-upsell__progress-marker--achieved');
          const svg = marker.querySelector('svg');
          if (svg) svg.style.fill = 'rgb(255, 255, 255)';
        } else {
          marker.classList.remove('cart-free-shipping-upsell__progress-marker--achieved');
          const svg = marker.querySelector('svg');
          if (svg) svg.style.fill = 'rgb(0, 0, 0)';
        }
      });
    }
  }

  customElements.define('cart-free-shipping-upsell', CartFreeShippingUpsell);
  } catch(e) { console.error(e); }
})();

})();
